import { Button, Layout, Skeleton } from "antd";
import { ReactComponent as Plus } from "assets/icons/plus-black.svg";
import { ReactComponent as Chat } from "assets/icons/chat.svg";
import { ReactComponent as ChatFilled } from "assets/icons/chat-filled.svg";

const { Sider } = Layout;

const ChatSideBar = ({
  collapsed,
  data,
  handleChatClick,
  windowWidth,
  onNewChatClick,
  sidebarItemRef,
  chatId,
  historyLoading,
}) => {
  const renderHistoryActiveIcon = (id) => {
    return chatId.includes(id) ? (
      <ChatFilled className="ml-2 min-w-5 min-h-5" />
    ) : (
      <Chat className="ml-2 min-w-5 min-h-5" />
    );
  };

  const renderContent = () => {
    return data?.map((item) => {
      return (
        <div
          className="bg-gray--9 p-2 flex m-6  justify-start rounded body-14px-regular text--gray-4  "
          onClick={() => handleChatClick(item.id)}
        >
          {renderHistoryActiveIcon(item.id)}
          <span className="!truncate">{item.title}</span>
        </div>
      );
    });
  };

  const renderIcon = () => {
    return <Plus className="[&>g>path]:fill-white" />;
  };

  const renderLoading = () => {
    return (
      <div className="flex flex-col space-y-3 mx-5 mt-6">
        <Skeleton.Button block />
        <Skeleton.Button block />
        <Skeleton.Button block />
        <Skeleton.Button block />
      </div>
    );
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      collapsedWidth="0"
      className={`${!collapsed
        ? windowWidth < 768
          ? "!min-w-72 drop-shadow-2xl "
          : " !min-w-80 shadow-lg"
        : ""
        }  mt-12  !bg-white`}
      theme="light"
    >
      <div
        className="!bg-white  !min-h-[calc(100vh-100px)] "
        ref={sidebarItemRef}
      >
        {historyLoading ? renderLoading() : renderContent()}
      </div>
      {!collapsed && (
        <div className=" max-w-80 w-full !sticky bottom-0 bg-white  p-5 ">
          <Button
            onClick={() => onNewChatClick()}
            icon={renderIcon()}
            className="primary-button-medium-with-icon "
            block
          >
            چت جدید
          </Button>
        </div>
      )}
    </Sider>
  );
};
export default ChatSideBar;
